import React, { useState, useEffect, useCallback } from "react";
import { Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { logout } from "../../../../utils";
import { ThreeCircles } from "react-loader-spinner";
import Select from "react-select";
import CygnusGrid from "../../../reusable_components/cygnus_grid/CygnusAgGrid";
import dayjs from "dayjs";


const ContentControllerComponent = (props) => {
    const [allFieldsMap, setAllFieldsMap] = useState(props.allfieldsmap)
    useEffect(() => {
        if (props.allfieldsmap !== undefined && props.allfieldsmap !== null) {
            if (allFieldsMap && JSON.parse(JSON.stringify(allFieldsMap)) !== JSON.parse(JSON.stringify(props.allfieldsmap))) {
                setAllFieldsMap(props.allfieldsmap)
            }
        }
    }, [props.allfieldsmap])

    const Switch = ({ isToggled, onClick }) => {
        return (
            <label className="switch">
                <input type="checkbox" checked={isToggled} onChange={onClick} style={{ appearance: "none" }} />
                <span className="super-admin-slider super-admin-round"></span>
            </label>
        );
    };

    const updateShowFlag = (id, event) => {
        setAllFieldsMap((prevMap) => {
            if (!prevMap) return prevMap; // Ensure data exists

            // Create a deep copy of prevMap to avoid mutating state directly
            const updatedMap = JSON.parse(JSON.stringify(prevMap));

            // Iterate through all keys and update the `show` flag
            Object.keys(updatedMap).forEach((key) => {
                if (Array.isArray(updatedMap[key])) {
                    updatedMap[key] = updatedMap[key].map(field =>
                        field.id === id ? { ...field, show: !field.show, replace: true } : field
                    );
                }
            });

            console.log("Updated allFieldsMap with new show flag:", updatedMap);
            props.setallfieldsmap(updatedMap)
            return updatedMap;
        });
    };


    const updateItem = (id, value) => {
        setAllFieldsMap((prevMap) => {
            if (!prevMap) return prevMap; // Ensure data exists

            // Create a deep copy of prevMap to avoid mutating state directly
            const updatedMap = JSON.parse(JSON.stringify(prevMap));

            // Iterate through all keys and update the `show` flag
            Object.keys(updatedMap).forEach((key) => {
                if (Array.isArray(updatedMap[key])) {
                    updatedMap[key] = updatedMap[key].map(field =>
                        field.id === id ? { ...field, value: value, replace: true } : field
                    );
                }
            });

            console.log("Updated allFieldsMap with new value:", updatedMap);
            props.setallfieldsmap(updatedMap)
            return updatedMap;
        });
    }


    return (
        <Row>
            <div className="flex-column-center-center">
                <h6>Other Inputs</h6>
                <p>Control the content of the template for your engagement</p>
            </div>

            {/* {
                allFieldsMap["Rules"].length > 0 ? <div className="flex-column-start-center">
                    <p style={{ fontWeight: 600 }}>Control Rules:</p>
                </div> :
                    <div className="flex-row-center-start">
                        <b>Note</b>: &nbsp;<i>No rules are included in this template.</i>.
                    </div>
            }
            {allFieldsMap["Rules"].length > 0 &&
                allFieldsMap["Rules"].map((item) => {
                    return <div className="toggler flex-row-center-start" style={{ margin: "5px 0px" }}>
                        <Switch
                            isToggled={item.replace}
                            onClick={event => updateShowFlag(item.id, event)}
                        ></Switch>
                        <label style={{ fontWeight: 600, fontSize: 10, marginLeft: 10 }}>{item.name}</label>
                    </div>
                })
            } */}
            {
                allFieldsMap["SelectedFields"].some(item => !item.inwizard) ? (
                    <div className="flex-column-start-center">
                        <p style={{ fontWeight: 600 }}>Other Fields:</p>
                    </div>
                ) : <div className="flex-row-center-start">
                    <b>Note</b>: &nbsp;<i>All fields of the engagement letter are already covered in fill information form section.</i>.
                </div>
            }

            {allFieldsMap["SelectedFields"].length > 0 &&
                allFieldsMap["SelectedFields"].map((item) => {
                    if (!item.inwizard) {
                        return <div className="flex-row-center-start" style={{ marginRight: 10, height: "fit-content" }}>
                            <div>
                                <label className="form-label move-left">{item.name}</label>
                                <input type="text" className="form-control move-left custom-input"
                                    placeholder={'Enter Value'}
                                    value={item.value}
                                    onChange={(e) => updateItem(item.id, e.target.value)}
                                    autoComplete="nope"
                                />
                            </div>
                            {/* <div style={{ marginTop: 7, marginBottom: -7 }}>
                                <Switch
                                    isToggled={item.show}
                                    onClick={event => updateShowFlag(item.id)}
                                ></Switch>
                            </div> */}
                        </div>
                    }
                })
            }
        </Row>
    );
};

export default ContentControllerComponent;
